<template>
    <div class="card-horizontal" :class="`card-horizontal__${index}`" v-if="donor">
        <div class="card-horizontal__user">
            <div class="card-horizontal__user-left">
                <a :href="`/pets/${donor.id}`" class="card-horizontal__user-photo">
                    <img :src="`/storage/${donor.avatar.path.replace('original', 'preview_l')}`" alt="user" v-if="donor.avatar">
                    <span v-text="getUserPM(donor.name)"></span>
                </a>
            </div>
            <div class="card-horizontal__user-right">
                <div class="card-horizontal__user-name d-flex">
                    <a :href="`/pets/${donor.id}`">
                        {{donor.name}}
                    </a>
                </div>


                <div class="card-horizontal__user-descr">
                    <span class="card-horizontal__user-descr-content" v-html="donor.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span>
                    <span class="card-horizontal__user-descr-content-read">... <a href='/donors' class='card-horizontal__user-descr-more'>Читать больше</a></span>
                </div>


                <div class="card-horizontal__user-type card-horizontal__user-type--donor d-flex" v-text="weightDictionary"></div>

                <div class="card-horizontal__user-contact d-flex">
                    <a :href="`tel:${donor.user.public_phone}`"  v-if="donor.user && donor.user.public_phone" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--icon">Позвонить</a>
                    <a href="/donors" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary">Отправить заявку</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Donor",
    props: ['donor', 'weight', 'index'],
    data(){
        return{}
    },

    computed:{
        weightDictionary(){
            let weight = this.weight

            switch(weight){
                case 'up_to_3':
                    weight = 'До 3 кг'
                    break;
                case 'up_to_6':
                    weight = '3-6 кг'
                    break;
                case 'up_to_10':
                    weight = '6-10 кг'
                    break;
                case 'up_to_15':
                    weight = '10-15 кг'
                    break;
                case 'up_to_25':
                    weight = '15-25 кг'
                    break;
                case 'up_to_35':
                    weight = '25-35 кг'
                    break;
                case '35_plus':
                    weight = '35 кг и более'
                    break;
                default:
                    weight = 'Не указано'
                    break;
            }

            return weight
        }
    },

    methods:{

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    }

}
</script>

<style scoped>

</style>
